
var ShiftSearchCtrl = function ($scope, $timeout) {

    var _this = this;

    $scope.searchCriteriaSelected = false
    $scope.$watchCollection("formModel.searchOptions.tagIdList", function(newValue,oldValue) {
        $scope.formModel.searchOptions.candidateListItemSelected = false
        angular.forEach($scope.formModel.searchOptions.tagIdList,function(value,key) {
           if(value == true) {
               $scope.formModel.searchOptions.candidateListItemSelected = true
           }
        });
    });

}
ShiftSearchCtrl.$inject = ['$scope', '$timeout'];
angular.module('app').controller('ShiftSearchCtrl',ShiftSearchCtrl);